export default "__VITE_ASSET__j5MHNn2y__"